import Preloader from './preloader'

export default Preloader



// WEBPACK FOOTER //
// ./client/components/productList/preloader/index.tsx